module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container",
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "-150px",
      "padding-bottom": "20px",
      "height": "200px"
    },
    attrs: {
      "src": "/static/img/getlocal-logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Sign In to your account")]), _vm._v(" "), _c('img', {
    staticClass: "sign-in-button",
    attrs: {
      "src": "/static/img/google_signin_buttons/web/1x/btn_google_signin_dark_normal_web.png"
    },
    on: {
      "click": _vm.signIn
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-475483f7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/Login.vue
// module id = 547
// module chunks = 1